import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario4 from "./Scenario4";

export default class Scenario4Part12 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 4;
	chapterIds = {
		
		scenario4_5B_s20: 'CALM - Scenario 4 End - 5B - Start - 4B - Segment 20',
		scenario4_5B_s21: 'CALM - Scenario 4 End - 5B - Start - 4B - Segment 21',
		scenario4_5B_s22: 'CALM - Scenario 4 End - 5B - Start - 4B - Segment 22',
	}

	constructor(scenario: Scenario4, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario4/calm-scenario4-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario4.parts.level4Part12.id;
	}

	public start() {
		const context = this;
		context.segment1Step2Dialogue();
	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;		
		this.scenario.dialog(
			'CN-C05-L3-050a',
			[{
				text: 'Listen to what Marco had to say at the in-service.',				
				scoreType: ScoreType.Zero,
				isCorrect: true // Rank zero (no points awarded)
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here
				context.scenario.evaluateAnswer(selectedOption, () => context.segment2Step1MarcoSpeaks(), context.partIndx);
			}
		);
		context.scenario.updateObjective('');
	}

	private segment2Step1MarcoSpeaks() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.playVideoChapter(context.chapterIds.scenario4_5B_s20, () => {
			context.segment2Step2Dialogue();
		});
	}

	private segment2Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;		
		context.scenario.updateObjective('');
		this.scenario.dialog(
			'CN-C05-L3-050b',
			[{
				text: 'Listen to what Heather had to say at the in-service.',				
				scoreType: ScoreType.Zero,
				isCorrect: true // Rank zero (no points awarded)
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here
				context.scenario.evaluateAnswer(selectedOption, () => context.segment3Step1HeatherSpeaks(), context.partIndx);
			}
		);
	}

	private segment3Step1HeatherSpeaks() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.playVideoChapter(context.chapterIds.scenario4_5B_s21, () => {
			context.segment3Step2Dialogue();
		});
	}

	private segment3Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;		
		this.scenario.dialog(
			'CN-C05-L3-050c',
			[{
				text: 'I\'m glad it went well. It\'s important that our staff knows how to use interpreter services.',				
				scoreType: ScoreType.Zero,
				isCorrect: true // Rank zero (no points awarded)
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here
				context.scenario.evaluateAnswer(selectedOption, () => context.segment4Step1GoToNSC(), context.partIndx);
			}
		);
		context.scenario.updateObjective('');
	}

	private segment4Step1GoToNSC() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.playVideoChapter(context.chapterIds.scenario4_5B_s22, () => {
			context.segment4Step2EnterMoreReports();
		});
	}

	private segment4Step2EnterMoreReports() {
		var context = this;
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: [
				{
					title: 'Incident',
					description: 'Nothing to add to report.'
				},
				{
					title: '24 Hour',
					description: 'Nothing to add to report.'
				},
				{
					title: 'End of Shift',
					description: 'Developed and scheduled an ad hoc in-service on interpretation services per Nurse Manager.'
				}
			],
			review: {
				text:
					`
						<p class="regular-description-font" style="margin: 0;">	
						As a Charge Nurse, you’re probably already aware that <span style="color: rgb(222, 225, 156)">trends in 
						health care and technology change all of the time.</span> <br /><br />
						Providing education in the form of <span style="color: rgb(222, 225, 156)"> time-sensitive in-services to 
						your staff</span> is one of the most cost-effective ways of keeping staff up to date. <span style="color: rgb(222, 225, 156)">
						Short ad hoc in-services can be held at almost any time in a facility.</span> A short timeslot should suffice 
						for briefing your staff on a new facility policy, an update to a piece of equipment, or a modification to 
						a procedure that they’ll be using; hands-on and in-depth understanding may require longer, more formal in-services. <br /><br />
						In this scenario, RN Marco and RN Heather shared their experiences with interpretive services at a staff meeting. In this way, staff 							
						learned from each other. <span style="color: rgb(222, 225, 156)"> Keeping your staff up to date, engaged, and knowledgeable 
						will help ensure your success as a Charge Nurse. </span>						
						</p>
						`
			},
			reflects: [
				{
					title: 'At your facility, are Charge Nurses responsible for providing in-services?',
					answer: ''
				},
				{
					title: 'How often does your unit conduct in-services?',
					answer: ''
				},
				{
					title: 'How are topics selected?',
					answer: ''
				},
				{
					title: 'In your facility, how does your staff review the in-service content if they miss the in-service session?',
					answer: ''
				},
				{
					title: 'How is the in-service attendance communicated and added to each staff member’s educational records in TMS?',
					answer: ''
				},
				{
					title: 'How do you decide if the in-service is done as part of shift changeover or if a separate session is conducted multiple days for large-group attendance?',
					answer: ''
				}
			],
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.partEnd();
			}
		})
	}

	private partEnd() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].points = CalmBaseScenario.scores[this.partIndx];

		this.scenario.gameManager.customData.saveData.scenarios[this.scenario.currentLevel].badges[context.partIndx].isUnlocked = true;
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;

		this.scenario.gameManager.customData.saveGame(this.scenario.gameManager);

		this.scenario.showBadgingUI(context.partIndx, () => {
			context.onDone();
		});
	}
}